import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import { Icon } from "../../ui";

const GiveawaysPage = lazy(() => import("./list").then((m) => ({ default: m.GiveawaysPage })));
const GiveawayPage = lazy(() => import("./giveaway").then((m) => ({ default: m.GiveawayPage })));
const GiveawaysSettings = lazy(() => import("./settings").then((m) => ({ default: m.GiveawaysSettings })));

/** Giveaways: fair giveaways for members, under Events. "/giveaways/new" opens a blank giveaway; saving makes it a draft. */

export const routes: SolutionRoute[] = [
  { solution: "giveaways", path: "giveaways", element: <GiveawaysPage /> },
  { solution: "giveaways", path: "giveaways/:id", element: <GiveawayPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "giveaways", key: "giveaways", label: "Giveaways", icon: Icon.star, need: "giveaways.view", Component: GiveawaysSettings }];
